import React, { Component } from "react";
import deletee from "../assets/delete.svg";
import block from "../assets/block.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class SuspectCellButton extends Component {
  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              حذف از لیست
            </Tooltip>
          }
        >
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => this.props.deleteItem(this.props.value)}
          >
            <img
              src={deletee}
              alt=""
              style={{ objectFit: "contain", height: "22px" }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              مسدود کردن تلفن
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "20px",
            }}
            onClick={() =>
              this.props.blockItem(this.props.value, this.props.data.phone)
            }
          >
            <img
              src={block}
              alt=""
              style={{ objectFit: "contain", height: "24px" }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}
